import React, {useEffect} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.less"
import {useGalleryController} from "../../../../controllers/gallery-controller";
import {getImageLink} from "../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../enums/buckets";
import {Spin} from "antd";
import HomeGalleryModal from "../../../../components/modals/homeGallery-modal/HomeGalleryModal";

type ReactSlickCarouselProps = {
  galleryController: ReturnType<typeof useGalleryController>
}

const ReactSlickCarousel = (props: ReactSlickCarouselProps) => {
  const {galleryController} = props
  const {isImagesLoading, images, getMainGalleryImages} = galleryController

  useEffect(() => {
    getMainGalleryImages()
  }, [])

  const settings = {
    className: "home-gallery-slider",
    centerMode: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 900,
    cssEase: "ease-in-out",
    fade: true,
    pauseOnHover: false,
    arrows: false,
    responsive: []
  };


  return <div className="slider-container">
    <Spin spinning={isImagesLoading}>
      <Slider {...settings}>
        {images.map((imageId, index) => {
          return <div className="home-gallery-slide" key={imageId}>
            <img className="home-gallery-slide__image" src={getImageLink({imageId, bucketId: BUCKETS.MAIN})}
                 alt={`Близнюківська центральна районна лікарня — фото ${index + 1}`}/>
          </div>
        })}
      </Slider>
    </Spin>
    {galleryController.isModalOpen && <HomeGalleryModal galleryController={galleryController}/>}
  </div>
}

export default ReactSlickCarousel
